import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6 } from "styled-components";
import { m } from "framer-motion";
import React from "react";
import { Button } from "~/features/ui/button";
import { Headline } from "~/features/ui/headline";
import { Link } from "~/features/ui/link";
import { Media } from "~/features/ui/media";
import { type DistributorCardFragment } from "~/gql/graphql";
import ArrowRight from "~/public/icons/arrow-right.svg";
type Props = DistributorCardFragment & {
  onMouseEnter: () => void;
  onMouseLeave: () => void;
};
export const InfoWindow = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const {
    title,
    url,
    logo,
    onMouseEnter,
    onMouseLeave
  } = props;
  const media = logo && logo.length >= 1 ? {
    imageAsset: logo
  } : undefined;
  return <_StyledMDiv ref={ref} initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <_StyledDiv $_css={[{
      "position": "relative",
      "display": "flex",
      "gap": "1.6rem",
      "overflow": "hidden",
      "borderRadius": "4px",
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
      "padding": "0.8rem",
      "paddingRight": "2.4rem"
    }, !media && {
      "paddingLeft": "1.6rem"
    }]}>
        {url && media && <_StyledLink href={url}>
            <Media {...media} imageProps={{
          ratio: "4/3",
          sizes: "lg:25vw"
        }} />
          </_StyledLink>}
        <_StyledDiv2>
          {title && <_StyledHeadline type="h2" text={title} />}
          {url && <_StyledDiv3>
              <Button as={Link} variant="underline" icon={ArrowRight} href={url} target="_blank" rel="noopener">
                Visit Website
              </Button>
            </_StyledDiv3>}
        </_StyledDiv2>
      </_StyledDiv>
    </_StyledMDiv>;
});
var _StyledMDiv = _styled(m.div).withConfig({
  componentId: "sc-sf-1tl0fqk-0"
})({
  "position": "fixed",
  "bottom": "0.8rem",
  "left": "0.8rem",
  "right": "0.8rem",
  "height": "max-content",
  "width": "max-content",
  "@media (min-width: 1024px)": {
    "--tw-translate-x": "-50%",
    "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))",
    "--tw-translate-y": "-50%"
  }
});
var _StyledDiv = _styled2("div").withConfig({
  componentId: "sc-sf-1tl0fqk-1"
})`${p => p.$_css}`;
var _StyledLink = _styled3(Link).withConfig({
  componentId: "sc-sf-1tl0fqk-2"
})({
  "display": "flex",
  "aspectRatio": "4/3",
  "height": "7.2rem",
  "width": "8.8rem",
  "alignItems": "center",
  "justifyContent": "center",
  "overflow": "hidden",
  "borderRadius": "4px"
});
var _StyledDiv2 = _styled4("div").withConfig({
  componentId: "sc-sf-1tl0fqk-3"
})({
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "flex-start",
  "paddingTop": "0.8rem",
  "paddingBottom": "0.8rem"
});
var _StyledHeadline = _styled5(Headline).withConfig({
  componentId: "sc-sf-1tl0fqk-4"
})({
  "fontSize": "2rem",
  "lineHeight": "1.3",
  "letterSpacing": "0.02rem",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "2.4rem",
    "lineHeight": "1.3",
    "letterSpacing": "0.024rem",
    "fontWeight": "400"
  }
});
var _StyledDiv3 = /*#__PURE__*/_styled6("div").withConfig({
  displayName: "distributor-info-window___StyledDiv3",
  componentId: "sc-1nu6t7l-0"
})({
  "marginTop": "auto"
});